const checkSliderArrowDisabledOrNo = (className: string): string => {
  const isDisabled = className.includes('slick-disabled');
  return isDisabled ? 'none' : 'block';
};
export default checkSliderArrowDisabledOrNo;
